import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import TimeGrid from 'react-big-calendar/lib/TimeGrid'
import {
	DateLocalizer,
	TitleOptions,
} from 'react-big-calendar';

export const WeekEndCustomView = ({
    date,
    localizer,
    max = localizer.endOf(new Date(), 'day'),
    min = localizer.startOf(new Date(), 'day'),
    scrollToTime = localizer.startOf(new Date(), 'day'),
    ...props
}: {
    date: Date;
    localizer: DateLocalizer;
    max: Date;
    min: Date;
    scrollToTime: Date;
}) => {
    const currRange = useMemo(
        () => WeekEndCustomView.range(date, { localizer }),
        [date, localizer],
    );

    return (
        <TimeGrid
            eventOffset={15}
            localizer={localizer}
            max={max}
            min={min}
            range={currRange}
            scrollToTime={scrollToTime}
            showAllEvents={false}
            allDayMaxRows={0}
            {...props}
        />
    );
}

WeekEndCustomView.propTypes = {
    date: PropTypes.instanceOf(Date).isRequired,
    localizer: PropTypes.object,
    max: PropTypes.instanceOf(Date),
    min: PropTypes.instanceOf(Date),
    scrollToTime: PropTypes.instanceOf(Date),
};

WeekEndCustomView.range = (
    date: Date,
    { localizer }: { localizer: DateLocalizer },
) => {
    const start = date;
    const end = localizer.add(start, 2, 'day');

    let current = start;
    const range = [];

    while (localizer.lte(current, end, 'day')) {
        range.push(current);
        current = localizer.add(current, 1, 'day');
    }

    return range;
};

WeekEndCustomView.navigate = (
    date: Date,
    action: string,
    { localizer }: { localizer: DateLocalizer },
) => {
    return date;
};

WeekEndCustomView.title = (date: Date, { localizer }: TitleOptions) => {
    const [start, ...rest] = WeekEndCustomView.range(date, { localizer });
    return localizer.format(
        { start: start, end: rest.pop() } as any,
        'dayRangeHeaderFormat',
    );
};
